import CryptoAES from 'crypto-js/aes';
import CryptoENC from 'crypto-js/enc-utf8';
import { random, padStart } from 'lodash';
import React from 'react';

/**
 * data 암호화
 * @param {} param0
 */
export const EnCryptData = (target) => {
    // console.log("EnCryptData Called : " + target);
    return CryptoAES.encrypt(target, process.env.REACT_APP_CIPHER);
}

/**
 * data 복호화
 * @param {*} param0
 */
export const DeCryptData = (target) => {
    let decrypted = CryptoAES.decrypt(target.toString(), process.env.REACT_APP_CIPHER);
    // console.log("CryptoENC : " + decrypted.toString(CryptoENC));
    return JSON.parse(decrypted.toString(CryptoENC));
}

export const Log = (msg) => {
    if (process.env.REACT_APP_HOST_ENV !== 'stage') {
        console.log(msg)
    }
}

export const OrderId = () => {
    const today = new Date();
    const year = today.getFullYear();
    let month = today.getMonth() + 1;
    let date = today.getDate();
    let hour = today.getHours();
    let minute = today.getMinutes();
    let second = today.getSeconds();
    let ms = today.getMilliseconds();
    let randomnum = random(9);

    month = padStart(month, 2, 0);
    date = padStart(date, 2, 0);
    hour = padStart(hour, 2, 0);
    minute = padStart(minute, 2, 0);
    second = padStart(second, 2, 0);
    ms = padStart(ms, 3, 0);

    let tmpOrderId = (year + "" + month + date + hour + minute + second + ms + randomnum);
    return tmpOrderId;
}
